import { Trans } from '@lingui/macro';
import { StyledText } from './styled';
export function ErrorMessage() {
    return (<StyledText size="tiny" appearance="neutral">
      <Trans>An error occurred, please try again.</Trans>
    </StyledText>);
}
